export enum FuelChartType {
  BYFUEL = 'BYFUEL',
  BYCATEGORY = 'BYCATEGORY',
}
